import React, { FunctionComponent } from 'react';
import { DealerLaunchStepProps } from '../types';
import { Dealer } from '../../../types/dealerTypes';
import { useLaunchpadForm } from '../../../hooks/useLaunchpadForm';
import { DealerLaunchFormCardLayout } from '../DealerLaunchFormCardLayout';
import styles from '../styles.module.scss';
import { TextField } from '../../Input/TextField/TextField';
import {
  emailValidatorFunction,
  phoneValidator,
} from '../../../utils/validation';

const title = 'How can we get in touch with your Finance Office?';
const subTitle =
  'Your finance office contact info is essential to enable Upstart Auto Retail Lending. We use this information to connect with your finance office for any questions related to lending.';
const cardTitle = 'Finance Contact';
const cardDescription =
  'Enter a contact name and phone number for your finance office.';

export const DealerLaunchLendingFinanceContact: FunctionComponent<DealerLaunchStepProps> = ({
  dealer,
  prevStep,
  nextStep,
}) => {
  const form = useLaunchpadForm<Dealer>({ defaultValues: dealer });

  return (
    <DealerLaunchFormCardLayout
      form={form}
      title={title}
      subTitle={subTitle}
      cardTitle={cardTitle}
      cardSubTitle={cardDescription}
      prevStep={prevStep}
      onFormSubmit={nextStep}
    >
      <div className={styles.stepRow}>
        <TextField
          label="Finance Contact Name (required)"
          tooltip="The first and last name of the best person to contact in your Finance Office."
          name="lending.contactInfo.name"
          width="md"
          form={form}
          validation={{ required: true }}
        />
        <TextField
          label="Finance Contact Email (required)"
          tooltip="The email address used for the finance contact in your Finance Office."
          name="financeEmail"
          width="md"
          type="email"
          form={form}
          validation={{ required: true, validate: emailValidatorFunction }}
        />
      </div>
      <div className={styles.stepRow}>
        <TextField
          label="Finance Phone (required)"
          tooltip="The direct phone number for the finance contact, or general finance office phone number."
          name="lending.contactInfo.phone"
          width="md"
          type="phone"
          form={form}
          mask="(999) 999-9999"
          validation={{ required: true, pattern: phoneValidator }}
        />
      </div>
    </DealerLaunchFormCardLayout>
  );
};
